import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {SelectItem, SelectItemGroup} from 'primeng/api';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {UploadedFileType} from '../helpers/file-status.enum';
import {Envelope, Postage, PostageConfig, PostagesConfig} from '../../../../model/postagesConfig';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {User} from "../../../../model/user";
import {AuthenticationService} from "../../../../services/apiServices/security/authentication.service";
import {TemplateConfig, TemplatesConfig} from "../../../../model/templatesConfig";
import {EmailValidator} from "../../../../model/email-validator";
import {Lre} from "../../../../model/lre";
import {Observable} from "rxjs";
import {DropdownService} from "../../../../services/crossComponent/drop-down.service";
import {Unsubscribable} from "../../../mixin/unsubscribable.component";
import {TypeBounceEnum} from '../../../../enums/dropdown.enums';
import {DepositDepotExpressEnum, ErlTypeEnum} from '../../../../enums/deposit.enums';

import {EncartConfig, EncartsConfig} from "../../../../model/encartsConfig";

import {instances} from "../../../../properties";
import {environment} from "../../../../../environments/environment";
import {StorageService} from "../../../../services/storage/storage.service";


@Component({
  selector: 'app-deposit-options',
  templateUrl: './deposit-options.component.html',
  styleUrls: ['./deposit-options.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DepositOptionsComponent extends Unsubscribable(class {}) implements OnInit {

  public user: User;

  @Input() depositType: string;
  @Input() typeErl: ErlTypeEnum;
  @Input() showButtonDeposit: boolean = true;
  @Input() senderAddress: any;
  @Input() showButtonMailing: boolean = true;
  @Input() showButtonMailingBounce: boolean = true;
  @Input() erl: Lre = null;

  @Output() signatureChange: EventEmitter<File>;
  @Output() hasBounce: EventEmitter<boolean>;
  @Output() moveNext: EventEmitter<boolean>;
  @Output() depositDirChange: EventEmitter<string>;
  @Output() hasMailingChange: EventEmitter<boolean>;

  typeBounce: string | null = null;
  dayBounce: number | null = null;

  printingType: string;
  printingQuality: string;
  archiving: boolean;
  hasAnnexes: boolean = false;
  hasFDP: boolean = false;
  positionFDP: string;
  hasSignature: boolean = false;
  hasDeposit: boolean = true;
  hasMailing: boolean = false;
  hasMailingBounce: boolean = false;
  public postages: SelectItemGroup[];
  public encarts: SelectItem[];
  public templates: SelectItemGroup[];
  public postageConfig: PostageConfig;
  public encartConfig: EncartConfig;
  public templateConfig: TemplateConfig;
  public envelopes: SelectItem[];
  public selectedPostage: string;
  public selectedEncart: string[] = [];
  public selectedTemplate: string;
  public selectedEnvelope: string;
  choicesFDP: SelectItem[];
  public FDP: File;
  public signature: File;
  public annexes: File[];
  public annexFileValidity: boolean;
  public fdpFileValidity: boolean;
  public sigFileValidity: boolean;
  public FileStatus = UploadedFileType;
  showDeposit: boolean = true;
  showMailing: boolean = false;
  showMailingBounce: boolean;
  public responseMail: string;
  public alias: string;
  public subject: string;
  public recipient: string;
  public isAuthorizedSendMail: boolean = false;
  public isAdminNumen: boolean = false;
  public typeBounceItems$: Observable<SelectItem[]> = this.dropdownService.getTypeBounceItems().pipe(this.takeUntilDestroyed());

  constructor(private createDepositService: CreateDepositService, private translate: TranslateService,
              private commonService: CommonService, private authenticationService: AuthenticationService,
              private dropdownService: DropdownService,
              private storageService: StorageService) {
    super();
    this.signatureChange = new EventEmitter<File>();
    this.moveNext = new EventEmitter<boolean>();
    this.hasMailingChange = new EventEmitter<boolean>();
    this.depositDirChange = new EventEmitter<string>();
    this.hasBounce = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.hasMailing = this.depositType === DepositDepotExpressEnum.ERL;
    this.user = this.authenticationService.getCurrentUser();
    this.isAdminNumen = this.authenticationService.isAdminNumen();
    if (this.isAdminNumen) {
      this.isAuthorizedSendMail = true;
    } else {
      this.isAuthorizedSendMail = this.user.isAuthorizedSendMail;
    }
    this.printingType = 'RS';
    this.printingQuality = 'COLOR';
    this.archiving = false;
    this.postages = [];
    this.encarts = [];
    this.templates = [];
    this.loadPostages();
    this.loadEncarts();
    this.selectedPostage = null;
    this.selectedEncart = null;
    this.selectedTemplate = null;
    this.selectedEnvelope = null;
    this.choicesFDP = [
      {label: this.translate.instant('UPLOAD_COMPONENT.FDP_ON_FIRST'), value: 'FIRST'},
      {label: this.translate.instant('UPLOAD_COMPONENT.FDP_ON_ALL'), value: 'ALL'},
    ];
    this.positionFDP = 'FIRST';
  }

  initEnvelope() {
    let selectedGroup;
    for(const group of this.postages){
      for(const item of group.items){
        if(item.value == this.selectedPostage){
          selectedGroup = group.label
        }
      }

    }
    this.archiving = selectedGroup=="Recommandé";
    this.selectedEnvelope = null;
    this.envelopes = [];
    if (this.selectedPostage) {
      const confEnvelopes: Envelope[] = this.postageConfig.getEnvelopes(this.selectedPostage);
      if (confEnvelopes && confEnvelopes.length > 0) {
        this.selectedEnvelope = confEnvelopes[0].value;
      }
      for (const e of confEnvelopes) {
        this.envelopes.push({label: e.label, value: e.value});
      }
    }

    // reset encart selections
    this.selectedEncart = [];
  }



  setFDPFlag(event: any) {
    setTimeout(() => {
      this.hasFDP = event.checked;
    }, 100);
  }

  setSignatureFlag(event: any) {
    this.hasSignature = event.checked;
  }

  setAnnexesFlag(event: any) {
    setTimeout(() => {
      this.hasAnnexes = event.checked;
    }, 100);
  }

  changeDayBounce() {
    if (this.dayBounce || this.dayBounce === 0) {
      if (this.dayBounce > 99) {
        this.dayBounce = 99;
      }
      if (this.dayBounce < 1) {
        this.dayBounce = 1
      }
    }
  }

  handleSwitchChange(type: string, event: any): void {
    setTimeout(() => {
      switch (type) {
        case 'deposit':
          this.hasDeposit = event.checked;
          this.resetMailingBounce();
          break;
        case 'mailing':
          this.hasMailing = event.checked;
          if (!this.hasMailing) {
            this.resetMailingBounce();
          } else {
            this.loadTemplates();
          }
          this.hasMailingChange.emit(this.hasMailing);
          break;
        case 'mailingBounce':
          this.hasMailingBounce = event.checked;
          break;
      }
    }, 100);
  }

  private resetMailingBounce(): void {
    this.showMailingBounce = false;
    this.hasMailingBounce = false;
    this.dayBounce = null;
    this.typeBounce = null;
  }

  // public nextEnabled(): boolean {
  // return this.selectedPostage && this.selectedEnvelope
  // && (!this.hasFDP || (this.hasFDP && this.FDP))
  //&& (!this.hasSignature || (this.hasSignature && this.signature))
  //&& (!this.hasAnnexes || (this.hasAnnexes && this.annexes !== undefined && this.annexes.length > 0));
  //}

  public nextEnabled(): boolean {
    if (this.hasMailing && !this.hasDeposit && !this.hasMailingBounce) {
      return this.selectedTemplate && (this.responseMail && this.isValidMail(this.responseMail))
        && (this.isRecipientOptional() || (this.recipient && this.isValidMail(this.recipient)))
        && (this.alias && this.alias.length > 0)
        && (this.subject && this.subject.length > 0) && (!this.hasFDP || (this.hasFDP && this.FDP))
        && (!this.hasSignature || (this.hasSignature && this.signature))
        && (!this.hasAnnexes || (this.hasAnnexes && this.annexes !== undefined && this.annexes.length > 0));
    } else if (this.hasMailing && this.hasDeposit && !this.hasMailingBounce) {
      return this.selectedPostage && this.selectedEnvelope && this.selectedTemplate
        && (this.responseMail && this.isValidMail(this.responseMail))
        && (this.isRecipientOptional() || (this.recipient && this.isValidMail(this.recipient)))
        && (this.alias && this.alias.length > 0)
        && (this.subject && this.subject.length > 0) && (!this.hasFDP || (this.hasFDP && this.FDP))
        && (!this.hasSignature || (this.hasSignature && this.signature))
        && (!this.hasAnnexes || (this.hasAnnexes && this.annexes !== undefined && this.annexes.length > 0));
    } else if ((this.hasMailing && !this.hasDeposit && this.hasMailingBounce)
      || (this.hasMailing && this.hasDeposit && this.hasMailingBounce)) {
      return this.selectedPostage && this.selectedEnvelope && this.selectedTemplate
        && (this.dayBounce && this.dayBounce > 0) && (this.responseMail && this.isValidMail(this.responseMail))
        && (this.responseMail && this.isValidMail(this.responseMail))
        && (this.isRecipientOptional() || (this.recipient && this.isValidMail(this.recipient)))
        && (this.alias && this.alias.length > 0)
        && (this.subject && this.subject.length > 0) && (!this.hasFDP || (this.hasFDP && this.FDP))
        && (!this.hasSignature || (this.hasSignature && this.signature))
        && (!this.hasAnnexes || (this.hasAnnexes && this.annexes !== undefined && this.annexes.length > 0));
    } else if (!this.hasMailing && this.hasDeposit && !this.hasMailingBounce) {
      return this.selectedPostage && this.selectedEnvelope
        && (!this.hasFDP || (this.hasFDP && this.FDP))
        && (!this.hasSignature || (this.hasSignature && this.signature))
        && (!this.hasAnnexes || (this.hasAnnexes && this.annexes !== undefined && this.annexes.length > 0));
    } else {
      return false;
    }
  }

  public nextEnabledERL(): boolean {
    // Validation des conditions liées à hasMailingBounce, typeBounce et dayBounce
    const isBounceValid = this.hasMailingBounce
      ? (this.typeBounce !== null &&
        ((this.typeBounce === TypeBounceEnum.DAY && this.dayBounce && this.dayBounce > 0) ||
          (this.typeBounce !== TypeBounceEnum.DAY && !this.dayBounce)))
      : (!this.typeBounce && !this.dayBounce);

    // Autres conditions
    const isFDPValid = !this.hasFDP || this.FDP;
    const isSignatureValid = !this.hasSignature || this.signature;
    const areAnnexesValid = !this.hasAnnexes || (this.annexes && this.annexes.length > 0);

    // Vérification finale
    return this.selectedPostage && this.selectedEnvelope &&
      isBounceValid &&
      isFDPValid && isSignatureValid && areAnnexesValid;
  }

  private formatAddressToSend(elementAddress: any) {
    let elementsList = Object.values(elementAddress);

    if (elementsList.length > 6) {
      elementsList[5] = elementsList[5] + " " + elementsList[7];

      elementsList.splice(7, 1);
    }

    return [...elementsList];
  }

  public storeDepositOptions() {
    const dataToSend = new FormData();

    dataToSend.append('type', this.depositType);
    this.selectedEncart.forEach((encart: string) => {
      dataToSend.append('encarts', encart)
    });
    const postage = this.selectedPostage;
    // Vérifier si les options de dépôt doivent être ajoutées
    if (this.hasDeposit || this.hasMailingBounce || this.hasMailing || !this.isAuthorizedSendMail) {
      dataToSend.append('postage', this.depositType !== DepositDepotExpressEnum.ERL ? postage : "LRE");
      dataToSend.append('archiving', this.archiving ? 'Y' : 'N');
      dataToSend.append('rectoVerso', this.printingType === 'RV' ? 'Y' : 'N');
      dataToSend.append('colorPrinting', this.printingQuality === 'COLOR' ? 'Y' : 'N');
      dataToSend.append('envelope', this.selectedEnvelope);
    }
    // Ajouter les options spécifiques
    if (this.hasFDP) {
      dataToSend.append('fdp', this.FDP);
      dataToSend.append('positionFDP', this.positionFDP);
    }
    if (this.hasSignature) {
      dataToSend.append('signature', this.signature);
    }
    if (this.hasAnnexes) {
      for (const annex of this.annexes) {
        dataToSend.append('annexes', annex);
      }
    }
    // Ajout des champs liés au mail
    if (this.hasMailing && this.depositType !== DepositDepotExpressEnum.ERL) {
      dataToSend.append('template', this.selectedTemplate);
      dataToSend.append('responseMail', this.responseMail);
      dataToSend.append('alias', this.alias);
      dataToSend.append('subject', this.subject);
      dataToSend.append('recipient', this.recipient);

      // if (this.hasMailingBounce) {
      //   dataToSend.append('mailTypeBounce', this.typeBounce);
      //
      //   if(this.typeBounce === TypeBounceEnum.DAY) {
      //     dataToSend.append('mailingBounce', this.dayBounce.toString());
      //   }
      // }

      if (this.hasMailingBounce) {
        dataToSend.append('mailingBounce', this.dayBounce.toString());
      }
    }

    // Ajout des champs liés à l'ERL
    if (this.depositType === DepositDepotExpressEnum.ERL && this.erl !== null) {
      dataToSend.append('erlSubject', this.erl.subject);
      dataToSend.append('erlRecipientTitle', this.erl.recipient.title);
      dataToSend.append('erlRecipientFirstName', this.erl.recipient.firstName);
      dataToSend.append('erlRecipientLastName', this.erl.recipient.lastName);
      dataToSend.append('erlRecipientCompany', this.erl.recipient.company);
      dataToSend.append('erlRecipientMailAddress', this.erl.recipient.mailAddress);
      dataToSend.append('erlRecipientPhoneNumber', this.erl.recipient.phoneNumber);
      dataToSend.append('erlRecipientAuthenticationType', this.erl.recipient.authenticationType);
      dataToSend.append('erlRecipientSignerQuality', this.erl.recipient.signerQuality);

      dataToSend.append('erlSenderTitle', this.erl.sender.title);
      dataToSend.append('erlSenderFirstName', this.erl.sender.firstName);
      dataToSend.append('erlSenderLastName', this.erl.sender.lastName);
      dataToSend.append('erlSenderCompany', this.erl.sender.company);
      dataToSend.append('erlSenderMailAddress', this.erl.sender.mailAddress);
      dataToSend.append('erlSenderPhoneNumber', this.erl.sender.phoneNumber);
      dataToSend.append('erlSenderAuthenticationType', this.erl.sender.authenticationType);
      dataToSend.append('erlSenderSignerQuality', this.erl.sender.signerQuality);
      dataToSend.append('erlSenderAddress', JSON.stringify(this.formatAddressToSend(this.senderAddress.elements)));
      dataToSend.append('hasBounce', this.showMailingBounce ? "Y" : "N");
      dataToSend.append('typeErl', this.typeErl);
      if (this.hasMailingBounce) {
        dataToSend.append('erlTypeBounce', this.typeBounce);

        if (this.typeBounce === TypeBounceEnum.DAY) {
          dataToSend.append('erlDayBounce', this.dayBounce.toString());
        }
      }
    }

    this.createDepositService.storeDepositOptions(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.depositDirChange.emit(response.depositDir);
        this.hasBounce.emit(this.showMailingBounce);
        this.moveNext.emit(true);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_STORE_OPTION_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_STORE_OPTION_MSG')
        });
      }
    });
  }

  public loadPostages() {
    this.createDepositService.getCustomerCFEId().subscribe(cfeIdResponse => {
      let cfeId = '';
      if (cfeIdResponse) {
        cfeId = cfeIdResponse;
      }

      this.createDepositService.getExpressDepositPostages(cfeId).subscribe(response => {
        this.postages = [];
        this.envelopes = [];
        if (response.langs) {
          const postagesConfig = new PostagesConfig(response);
          this.postageConfig = postagesConfig.getPostageConfig(this.translate.currentLang);
          for (const g of this.postageConfig.groups) {
            const entry: SelectItemGroup = {
              items: [],
              label: g.label,
              value: g.value
            };
            if (g.postages) {
              for (const p of g.postages) {
                entry.items.push({label: p.label, value: p.value+`${p.encart ? '(encart)' : ''}`});
              }
            }
            this.postages.push(entry);
          }
          if (this.postages.length > 0) {
            this.selectedPostage = this.postages[0].items[0].value;
            this.initEnvelope();
          }
        } else {
          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.translate.instant('UPLOAD_COMPONENT.MISSING_POSTAGES_TITLE'),
            detail: this.translate.instant('UPLOAD_COMPONENT.MISSING_POSTAGES_MSG')
          });
        }
      });
    })
  }

  public loadEncarts() {
      const customer = this.storageService.getCurrentUserInStorage();

      this.createDepositService.getExpressDepositEncart(customer.idCustomer).subscribe((response) => {
        this.encarts = response.map(encart => ({
          label: encart.libelle,
          value: `reference=${encart.reference} poids=5000`,
        }));
      });
  }

  public verifySelectedEncartLength() {
    if(this.selectedEncart.length > 4) {
      this.selectedEncart.pop();
    }
  }

  loadTemplates(): void {
    this.createDepositService.getExpressDepositTemplates().subscribe(response => {
      this.templates = [];
      if (response.groups) {
        const templatesConfig = new TemplatesConfig(response);
        this.templateConfig = templatesConfig.getTemplateConfig();
        for (const g of this.templateConfig.groups) {
          const entry: SelectItemGroup = {
            items: [],
            label: g.label,
            value: g.value
          };
          if (g.templates) {
            for (const p of g.templates) {
              entry.items.push({label: p.label, value: p.value});
            }
          }
          this.templates.push(entry);
        }
      } else if (response.customerId !== null && response.customerId !== undefined) {
        return;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_MSG')
        });
      }
    });
  }

  public updateUploadValidity(fileType: string, validityFromChild: boolean) {
    switch (fileType) {
      case UploadedFileType.ANNEX:
        this.annexFileValidity = validityFromChild;
        break;
      case UploadedFileType.FDP:
        this.fdpFileValidity = validityFromChild;
        break;
      case UploadedFileType.SIG:
        this.sigFileValidity = validityFromChild;
        break;
    }
  }

  public setSignatureFile(fileType: string, files: File[]) {
    if (files && files.length > 0) {
      this.signature = files[0];
    } else {
      this.signature = null;
    }
    this.signatureChange.emit(this.signature);
  }

  public setFDPFile(fileType: string, files: File[]) {
    if (files && files.length > 0) {
      this.FDP = files[0];
    } else {
      this.FDP = null;
    }
  }

  public setAnnexes(fileType: string, files: File[]) {
    if (!files || files.length < 1) {
      this.annexes = [];
    } else {
      this.annexes = files;
    }
  }

  public getListOfAcceptedFiles(fileStatus: string): string[] {
    switch (fileStatus) {
      case UploadedFileType.MAIN:
        return ['pdf', 'doc', 'docx', 'odt'];
      case UploadedFileType.ANNEX:
        return ['pdf', 'doc', 'docx', 'odt'];
      case UploadedFileType.DATA:
        return ['xlsx', 'xls', 'csv'];
      default:
        return [];
    }
  }

  private isRecipientOptional(): boolean {
    return this.depositType === DepositDepotExpressEnum.MAILING;
  }

  public isValidMail(mail: string): boolean {
    return EmailValidator.emailIsValid(mail);
  }

  onTypeBounceChange(typeBounce: string): void {
    if (typeBounce !== TypeBounceEnum.DAY) {
      this.dayBounce = null;
    }
  }

  protected readonly TypeBounceEnum = TypeBounceEnum;
  protected readonly DepositDepotExpressEnum = DepositDepotExpressEnum;
  protected readonly ErlTypeEnum = ErlTypeEnum;
}
